// extracted by mini-css-extract-plugin
export var antSteps = "aspect-ratio-module--ant-steps--Ixdaz";
export var antStepsDot = "aspect-ratio-module--ant-steps-dot--wIPQY";
export var antStepsHorizontal = "aspect-ratio-module--ant-steps-horizontal--kJECu";
export var antStepsItemDescription = "aspect-ratio-module--ant-steps-item-description--QhXkp";
export var antStepsItemIcon = "aspect-ratio-module--ant-steps-item-icon--Bu65j";
export var antStepsItemTitle = "aspect-ratio-module--ant-steps-item-title--S5ITS";
export var antStepsSmall = "aspect-ratio-module--ant-steps-small--tzZ9w";
export var antTypography = "aspect-ratio-module--ant-typography--MS5St";
export var hideOnReducedMotion = "aspect-ratio-module--hideOnReducedMotion--0mtmk";
export var noBullet = "aspect-ratio-module--noBullet--hA9rY";
export var showOnReducedMotion = "aspect-ratio-module--showOnReducedMotion--hTJL9";
export var tweetBox = "aspect-ratio-module--tweet-box--+k2ah";
export var wrapper = "aspect-ratio-module--wrapper--kXJ36";